import { useCallback, useEffect, useState } from "react";

const useRevealOnScroll = ({
  threshold = 0.2,
  rootMargin = "0px",
  once = true,
} = {}) => {
  const [element, setElement] = useState(null);
  const [visible, setVisible] = useState(false);

  const ref = useCallback((node) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) {
      return;
    }

    if (once && visible) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);

        if (entry.isIntersecting && once) {
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element, threshold, rootMargin, once, visible]);

  return {
    ref,
    visible,
  };
};

export default useRevealOnScroll;